import React from 'react';
import {useLocation} from "react-router-dom";
import { useAsync } from 'react-async-hook';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { roommemberApi } from '../apis/roommember/roommemberApi';
import { StopRoomMemberModal } from '../components/pages/RoomMember/StopRoomMemberModal';
import { RoomMember } from '../types/types';
import icon442 from '../assets/images/ROOM_TaskBoard_Re4_42.png';
import useLoading from '../hooks/useLoading';
import {NoDataMessage} from "../components/pages/common/table/NoDataMessage";
import useAppRouter from "../hooks/useAppRouter";
import {useAuth} from "../hooks/useAuth";
import {logError} from "../libs/utils/logError";

// eslint-disable-next-line no-shadow
enum Role {
  SalesManager = 1,
  SalesMember,
  Owner,
  Guest,
}


export const RoomMemberPage: React.FC = () => {
  const { goto } = useAppRouter();
  const { state: { currentUser } } = useAuth();
  if(currentUser?.accessRoomIds.every( id => id !== currentUser?.roomId)) {
    goto('forbiddenError');
  }
  const [roomMembers, setRoomMembers] = React.useState<RoomMember[]>([]);
  const [showStopModal, setShowStopModal] = React.useState<boolean>(false);
  const [roomMember, setRoomMember] = React.useState<RoomMember | undefined>();
  const [ownerFlg, setOwnerFlg] = React.useState<boolean>(false);
  const withLoading = useLoading();
  const location = useLocation();

  const { execute: reloadRoomMember } = useAsync(async () => {
    const fetch = async () => {
      withLoading(async () => {
        try {
          const response = await roommemberApi.index({});
          setRoomMembers(response.memberList);
          setOwnerFlg(response.ownerFlg);
        } catch(e) {
          await logError(
            location.pathname,
            '参加者一覧の取得に失敗しました。',
            e
          );

          goto('internalServerError');
        }
      });
    };
    fetch();
  }, []);

  const handleClick = (rm: RoomMember) => {
    setRoomMember(rm);
    setShowStopModal(true);
  };

  const onSubmitted = async () => {
    await reloadRoomMember();
    setShowStopModal(false);
  };

  return (
    <>
      {showStopModal && roomMember && (
        <StopRoomMemberModal {...{ roomMember, onSubmitted }} />
      )}
      <div className="bg-sub p-8">
        <div className="container mx-auto h-full min-h-screen">
          <div className="overflow-x-auto whitespace-nowrap block">
            <table className="file-table">
              <thead className="bg-primary text-white text-xs w-full">
                <tr>
                  <th className="py-1">名前</th>
                  <th className="py-1">会社名</th>
                  <th className="py-1">E-mail</th>
                  <th className="py-1">ステータス</th>
                  <th className="py-1">動作</th>
                </tr>
              </thead>
              <tbody className="bg-white text-sm">
                {roomMembers.map((rm) => (
                  <tr key={rm.id}>
                    <td className="p-4 font-medium w-1/4 whitespace-normal">
                      <div className="flex items-center">
                        <img src={icon442} alt="icon" />
                        <div className="ml-4 break-all">{rm.name}</div>
                      </div>
                    </td>
                    <td className="p-4 w-1/4 whitespace-normal">
                      {rm.companyName === '' ? 'ー' : rm.companyName}
                    </td>
                    <td className="p-4 w-1/4 text-xs whitespace-normal">
                      {rm.email}
                    </td>
                    <td className="px-4 text-xs whitespace-nowrap">
                      {rm.disabledFlg ? '停止中' : '参加中'}
                    </td>
                    <td className="px-4">
                      <div className="flex items-center justify-center">
                        {ownerFlg && rm.roleId === Role.Guest ? (
                          <>
                            <button
                              type="button"
                              className="outline-none focus:outline-none"
                              onClick={() => handleClick(rm)}
                            >
                              <FontAwesomeIcon
                                icon={faMinusCircle}
                                size="2x"
                                className="text-gray-500"
                              />
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            { roomMembers.length === 0 && (
              <div className="mt-6">
                <NoDataMessage />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
